export enum TabHeader {
  MAGAZINES = 'Magasiner',
  NEWSPAPERS = 'Aviser',
  MAGAZINE_ISSUERS = 'Magasin-utgivere',
  NEWSPAPER_ISSUERS = 'Avis-utgivere',
}
